<template>
  <div class="logOffScuess_box">
    <div class="success_icon">
      <img src="../../assets/images/achieved.png"
           alt="">
      <p>{{successTitle}}</p>
    </div>
    <li class="form_item form_submit"
        @click="getNextStep"
        ref='form_submit'>
      {{$t('successText.goBack')}}
    </li>
  </div>
</template>

<script>
import { getSessionStorage } from '@/utils/stage'
export default {
  data() {
    return {
      successTitle: '',
      id: '',
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.id = parseInt(this.$route.query.id)
      let successTitle
      switch (this.id) {
        case 1:
          successTitle = this.$t('successText.successTitle1')
          break
        case 2:
          successTitle = this.$t('successText.successTitle2')
          break
        case 3:
          successTitle = this.$t('successText.successTitle3')
          break
        case 4:
          successTitle = this.$t('successText.successTitle4')
          break
        case 5:
          successTitle = this.$t('successText.successTitle4')
          break
        case 6:
          successTitle = this.$t('successText.successTitle4')
          break
        case 7:
          successTitle = this.$t('successText.successTitle1')
          break
      }
      this.successTitle = successTitle
    },
    getNextStep() {
      const homePage = getSessionStorage('homePage')
      if (this.id == 7) {
        this.$router.push('/accountHome')
      } else {
        this.$router.push(homePage)
      }
    },
  },
}
</script>

<style scoped lang='less'>
.logOffScuess_box {
  padding: 30px;
  height: 100%;
  box-sizing: border-box;
  //   position: relative;
  .success_icon {
    width: 300px;
    margin: 0 auto;
    margin-top: 55px;
    text-align: center;
    font-size: 30px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #646464;
    img {
      width: 120px;
      height: auto;
      margin: 0 auto;
      margin-bottom: 25px;
    }
  }
  .logOffScuess_title {
    font-size: 30px;
    font-weight: 700;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #646464;
  }
  .form_submit {
    width: 190px;
    height: 60px;
    background: #ff7391;
    opacity: 1;
    border-radius: 6px;
    font-family: 'Microsoft YaHei';
    font-size: 20px;
    color: #fff;
    line-height: 60px;
    letter-spacing: 3px;
    position: absolute;
    bottom: 160px;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
    cursor: pointer;
    position: absolute;
    bottom: 80px;
  }
}
</style>